import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Card,
  CardHeader,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  CardContent,
  Grid,
  Button,
  CircularProgress,
} from "@mui/material";
import {
  getCitiesAction,
  getCountriesAction,
  getStatesAction,
} from "../../redux/action";
import { appSelector } from "../../redux/selector";
import axios from "axios";
import Key from "../../../clientVariables.json";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { myCandidatesSelector } from "../redux/selector";

const ContactInformation = ({ formDataHnadler }) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    country: "",
    state: "",
    city: "",
  });

  const [formErrors, setFormErrors] = useState({
    country: "",
    state: "",
    city: "",
  });

  const { statesList, citiesList, countriesList } = useSelector(appSelector);

  const { candidateDetails } = useSelector(myCandidatesSelector);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const handleOpenSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  useEffect(() => {
    dispatch(getCountriesAction());
  }, [dispatch]);

  useEffect(() => {
    const fetch = async () => {
      try {
        const country = await countriesList.filter(
          (item) => item.id === candidateDetails?.country_id
        );
        const state = await countriesList.filter(
          (item) => item.id === candidateDetails?.state_id
        );
        const city = await countriesList.filter(
          (item) => item.id === candidateDetails?.city_id
        );
        setFormData({
          country:
            candidateDetails?.country_id !== undefined &&
            candidateDetails?.country_id !== null &&
            candidateDetails?.country_id !== "undefined" &&
            candidateDetails?.country_id !== ""
              ? candidateDetails.country_id
              : "",
          state:
            candidateDetails?.state_id !== undefined &&
            candidateDetails?.state_id !== null &&
            candidateDetails?.state_id !== "undefined" &&
            candidateDetails?.state_id !== ""
              ? candidateDetails.state_id
              : "",
          city:
            candidateDetails?.city_id !== undefined &&
            candidateDetails?.city_id !== null &&
            candidateDetails?.city_id !== "undefined" &&
            candidateDetails?.city_id !== ""
              ? candidateDetails.city_id
              : "",
        });
        await formDataHnadler(formData, "f3");
      } catch (error) {
        console.error(error);
      }
      if (
        candidateDetails?.country_id !== undefined &&
        candidateDetails?.country_id !== null &&
        candidateDetails?.country_id !== "undefined" &&
        candidateDetails?.country_id !== ""
      ) {
        dispatch(getStatesAction(candidateDetails?.country_id));
      }
      if (
        candidateDetails?.state_id !== undefined &&
        candidateDetails?.state_id !== null &&
        candidateDetails?.state_id !== "undefined" &&
        candidateDetails?.state_id !== ""
      ) {
        dispatch(getCitiesAction(candidateDetails?.state_id));
      }
    };
    fetch();
  }, [candidateDetails]);

  const handleCountryChange = (event) => {
    const selectedCountry = event.target.value;
    setFormData({
      country: selectedCountry,
      state: "",
      city: "",
    });

    dispatch(getStatesAction(selectedCountry));
  };

  const handleStateChange = (event) => {
    const selectedState = event.target.value;
    setFormData({
      ...formData,
      state: selectedState,
      city: "",
    });

    dispatch(getCitiesAction(selectedState));
  };

  const validateForm = () => {
    let valid = true;
    const errors = {};

    if (!formData.country) {
      errors.country = "Country is required";
      valid = false;
    }

    if (!formData.state) {
      errors.state = "State is required";
      valid = false;
    }

    if (!formData.city) {
      errors.city = "City is required";
      valid = false;
    }

    setFormErrors(errors);

    return valid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);
    await formDataHnadler(formData, "f3");

    try {
      const country = await countriesList.filter(
        (item) => item.id === formData.country
      );
      const state = await statesList.filter(
        (item) => item.id === formData.state
      );
      const city = await citiesList.filter((item) => item.id === formData.city);
      const response = await axios.post(
        `${Key.domain}/candidate/update/contact/${candidateDetails?.candidate_id}`,
        {
          country_name: country[0].name,
          country_id: country[0].id,
          state_name: state[0].name,
          state_id: state[0].id,
          city_name: city[0].name,
          city_id: city[0].id,
        }
      );

      handleOpenSnackbar("candidate details updated successfully", "success");
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Card sx={cardStyles}>
      <CardHeader
        title={
          <Typography variant="h6" sx={headerStyles}>
            Contact Information
          </Typography>
        }
      />
      <CardContent
        sx={{
          ".css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input":
            { padding: "8px 6px" },
        }}
      >
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  Country
                </Typography>
                <Select
                  labelId="country-label"
                  id="country"
                  label=""
                  placeholder="Country"
                  value={formData.country}
                  onChange={handleCountryChange}
                  sx={inputStyles}
                >
                  <MenuItem value="" disabled>
                    Select Country
                  </MenuItem>
                  {countriesList &&
                    countriesList?.map((country, index) => (
                      <MenuItem key={index} value={country.id}>
                        {country.name}
                      </MenuItem>
                    ))}
                </Select>
                {formErrors.country && (
                  <Typography variant="caption" color="error">
                    {formErrors.country}
                  </Typography>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  State
                </Typography>
                <Select
                  labelId="state-label"
                  id="state"
                  label=""
                  placeholder="State"
                  value={formData.state}
                  onChange={handleStateChange}
                  disabled={!formData.country}
                  sx={inputStyles}
                >
                  <MenuItem value="" disabled>
                    Select State
                  </MenuItem>
                  {statesList &&
                    statesList?.map((state, index) => (
                      <MenuItem key={index} value={state.id}>
                        {state.name}
                      </MenuItem>
                    ))}
                </Select>
                {formErrors.state && (
                  <Typography variant="caption" color="error">
                    {formErrors.state}
                  </Typography>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  City
                </Typography>
                <Select
                  labelId="city-label"
                  id="city"
                  label=""
                  placeholder="City"
                  value={formData.city}
                  onChange={(event) =>
                    setFormData({ ...formData, city: event.target.value })
                  }
                  disabled={!formData.state}
                  sx={inputStyles}
                >
                  <MenuItem value="" disabled>
                    Select City
                  </MenuItem>
                  {citiesList &&
                    citiesList?.map((city, index) => (
                      <MenuItem key={index} value={city.id}>
                        {city.name}
                      </MenuItem>
                    ))}
                </Select>
                {formErrors.city && (
                  <Typography variant="caption" color="error">
                    {formErrors.city}
                  </Typography>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12} textAlign="end">
              <Button
                type="submit"
                variant="contained"
                sx={{ bgcolor: "#406882" }}
              >
                {isSubmitting ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  "Save Changes"
                )}
              </Button>
            </Grid>
          </Grid>
        </form>
      </CardContent>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </Card>
  );
};

export default ContactInformation;

const cardStyles = {
  boxShadow: "none",
  borderRadius: "8px",
};

const headerStyles = {
  color: "rgb(102, 120, 156)",
  fontSize: "16px",
  fontWeight: 600,
};

const labelStyles = {
  color: "rgb(160, 171, 184)",
  marginBottom: "5px",
};

const inputStyles = {
  border: "1px solid rgb(224, 230, 247)",
  borderRadius: "4px",
  "&:hover": {
    border: "1px solid rgb(224, 230, 247)",
    borderRadius: "4px",
  },
};
